import { AppConfig } from './AppConfig';

const baseUrl = 'http://ec2-63-33-193-111.eu-west-1.compute.amazonaws.com';
const basePlannerUrl = 'http://ec2-63-33-193-111.eu-west-1.compute.amazonaws.com:8080';

const config: AppConfig = {
  configName: 'RUN-S2v2-S1-2021-v2',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/RUN-S2v2-S1-2021-v2/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
};

export default config;
